import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Tokens from "@/pages/Tokens";

export const Route = createFileRoute("/_app/markets/")({
  component: () => (
    <PageGate pageKey="tokens"><Tokens /></PageGate>
  ),
});
